import { Editor } from 'codemirror';

export type CodeMirrorMark = CodeMirror.TextMarker<CodeMirror.MarkerRange>;

export interface ClickedMarksAndMouseEvent {
  marks: CodeMirrorMark[];
  event: MouseEvent;
}

export class MarksHelper {
  static createLinkMark(editor, start, end) {
    return MarksHelper.createMark(editor, start, end, 'editor2-link');
  }

  static createBadSpellingMark(editor, start, end) {
    return MarksHelper.createMark(editor, start, end, 'editor2-badspelling');
  }

  static createTooLongMark(editor, start, end) {
    return MarksHelper.createMark(editor, start, end, 'editor2-toolong');
  }

  static createTwitterMentionMark(editor, start, end) {
    return MarksHelper.createMark(editor, start, end, 'editor3-tw-mention');
  }

  static createTwitterHashtagMark(editor, start, end) {
    return MarksHelper.createMark(editor, start, end, 'editor3-tw-hashtag');
  }

  static createEditor3LinkMark(editor, start, end) {
    return MarksHelper.createMark(editor, start, end, 'editor3-link');
  }

  static createMark(editor: Editor, start: CodeMirror.Position, end: CodeMirror.Position, cssClass: string) {
    return editor.getDoc().markText(start, end, { className: cssClass });
  }

  /**
   * Tells whether the given mouse event was triggered on clicable marked text.
   * We need to check this because if the last char of the editor is marked,
   * for any click for exemple just below the text,
   * doc.findMarksAt(pos) will return the mark the last char is part of,
   * which would trigger the context menu (which is a very annoying behaviour)
   */
  static targetIsMark(event) {
    return !!event.target.className.match(/editor2-link|editor2-badspelling/);
  }

  static markMention(editor, from, mentionPlaceholderForBackend: string, toUserName) {
    const replacementSpan = document.createElement('span');
    replacementSpan.className = 'editor2-fb-mention';
    replacementSpan.appendChild(document.createTextNode(toUserName));
    const to = {
      line: from.line,
      ch: +from.ch + mentionPlaceholderForBackend.length,
    };
    editor.getDoc().markText(from, to, {
      replacedWith: replacementSpan,
    });
  }
}
